export enum InvitationInstance {
    head= 'Head',
    mares = 'Mares',
    tyrolia = 'Tyrolia',
    zoggs = 'Zoggs',
    divessi = 'DiveSSI',
}
